import styles from "./Support.module.scss";
import { useEffect } from "react";

const Support = () => {
  useEffect(() => {
    document.title = "Support | Amenigies";
  }, []);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Amenigies Support</h1>
      </div>

      <div className={styles.descriptionContainer}>
        <p className={styles.description}>
          Amenigies helps tenants access and manage building amenities through a
          mobile application. If you are experiencing any issues, we are here to
          help.
        </p>
      </div>

      <div className={styles.card}>
        <h2 className={styles.cardTitle}>Contact Support</h2>

        <p className={styles.cardText}>
          📧 Email:{" "}
          <a href="mailto:info@amenigies.com" className={styles.link}>
            info@amenigies.com
          </a>
          <br />⏱ Response Time: Within 24 hours
        </p>
      </div>

      <div className={styles.card}>
        <h2 className={styles.cardTitle}>Common Questions</h2>

        <div className={styles.faqItem}>
          <strong className={styles.faqQuestion}>
            How do I cancel my subscription?
          </strong>

          <p className={styles.faqAnswer}>
            You can cancel your subscription anytime from your account settings.
            Access will remain active until your next billing date.
          </p>
        </div>

        <div className={styles.faqItem}>
          <strong className={styles.faqQuestion}>
            Why can't I access amenities?
          </strong>

          <p className={styles.faqAnswer}>
            Access depends on your active subscription and lease status. Please
            ensure both are valid.
          </p>
        </div>

        <div className={styles.faqItem}>
          <strong className={styles.faqQuestion}>
            What happens when my lease ends?
          </strong>

          <p className={styles.faqAnswer}>
            Your access to amenities will automatically be revoked once your
            lease expires or is terminated.
          </p>
        </div>

        <div className={styles.faqItem}>
          <strong className={styles.faqQuestion}>
            App is not working properly?
          </strong>

          <p className={styles.faqAnswer}>
            Please email us with details of the issue, including screenshots if
            possible, and we will assist you.
          </p>
        </div>
      </div>

      <div className={styles.card}>
        <h2 className={styles.cardTitle}>Legal</h2>

        <div className={styles.legalLinks}>
          <a href="/terms" className={styles.link}>
            Terms & Conditions
          </a>

          <a href="/privacy" className={styles.link}>
            Privacy Policy
          </a>
        </div>
      </div>

      <div className={styles.footer}>
        © 2026 Amenigies LLC. All rights reserved.
      </div>
    </div>
  );
};

export default Support;
